module.exports = __webpack_public_path__ + "assets/img/hotel-img-room.798542c0.jpg";